import bolsaNoContratadosService from "@/services/bolsaNoContratados.services";

const formatFecha = (valor) => {
  if (!valor) return null;
  try {
    const date = new Date(valor);
    if (isNaN(date.getTime())) return valor;
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear();
    const h = date.getHours();
    const mm = String(date.getMinutes()).padStart(2, '0');
    const suffix = h >= 12 ? 'pm' : 'am';
    const h12 = String(h % 12 || 12).padStart(2, '0');
    return `${d}/${m}/${y} ${h12}:${mm} ${suffix}`;
  } catch {
    return valor;
  }
};

const mapPersona = (persona) => ({
  id: persona.id_persona,
  tipoDocumento: persona.tipo_documento,
  noDocumento: persona.numero_documento,
  nombres: persona.nombres,
  apellidos: persona.apellidos,
  telefono: persona.telefono,
  evaluaciones: persona.evaluaciones ?? [],
  detalleCandidato: {
    personData: {
      nombre: `${persona.nombres ?? ""} ${persona.apellidos ?? ""}`.trim(),
      avatar: null,
    },
    personalData: [
      { label: "Tipo de documento", value: persona.tipo_documento },
      { label: "No. de documento", value: persona.numero_documento },
      { label: "País de nacimiento", value: persona.pais_nacimiento },
      { label: "Fecha de nacimiento", value: persona.fecha_nacimiento },
      { label: "Teléfono personal", value: persona.telefono },
      { label: "Departamento de residencia", value: persona.departamento_residencia },
      { label: "Distrito de residencia", value: persona.distrito_residencia },
      { label: "Dirección", value: persona.direccion },
      { label: "Email personal", value: persona.email_personal },
    ],
  },
});

export default {
  namespaced: true,
  state: {
    idOferta: null,
    datosSolicitud: null,
    listaCandidatosSeleccionados: [],
    listaCandidatosDescartados: [],
    totalSeleccionados: 0,
    totalDescartados: 0,
    detalleCandidato: null,
    bitacora: [],
  },
  mutations: {
    SET_ID_OFERTA(state, payload) {
      state.idOferta = payload;
    },
    SET_DATOS_SOLICITUD(state, payload) {
      state.datosSolicitud = payload;
    },
    SET_CANDIDATOS_SELECCIONADOS(state, payload) {
      state.listaCandidatosSeleccionados = payload;
      state.totalSeleccionados = payload.length;
    },
    SET_CANDIDATOS_DESCARTADOS(state, payload) {
      state.listaCandidatosDescartados = payload;
      state.totalDescartados = payload.length;
    },
    SET_DETALLE_CANDIDATO(state, payload) {
      state.detalleCandidato = payload;
    },
    MOVER_A_SELECCIONADOS(state, candidatoId) {
      const index = state.listaCandidatosDescartados.findIndex(
        (c) => c.id === candidatoId
      );
      if (index !== -1) {
        const candidato = state.listaCandidatosDescartados.splice(index, 1)[0];
        state.listaCandidatosSeleccionados.push(candidato);
        state.totalDescartados = state.listaCandidatosDescartados.length;
        state.totalSeleccionados = state.listaCandidatosSeleccionados.length;
      }
    },
    MOVER_A_DESCARTADOS(state, candidatoId) {
      const index = state.listaCandidatosSeleccionados.findIndex(
        (c) => c.id === candidatoId
      );
      if (index !== -1) {
        const candidato = state.listaCandidatosSeleccionados.splice(
          index,
          1
        )[0];
        state.listaCandidatosDescartados.push(candidato);
        state.totalSeleccionados = state.listaCandidatosSeleccionados.length;
        state.totalDescartados = state.listaCandidatosDescartados.length;
      }
    },
    SET_BITACORA(state, payload) {
      state.bitacora = payload;
    },
  },
  actions: {
    setIdSolicitud({ commit }, id) {
      commit("SET_ID_OFERTA", id);
    },
    async fetchDatosSolicitud({ commit, state }) {
      const response = await bolsaNoContratadosService.getDetalleGeneral(
        state.idOferta
      );
      if (response?.status === 200) {
        const data = response.data;
        commit("SET_DATOS_SOLICITUD", {
          idSolicitud: data.id_solicitud,
          datosUnidad: {
            unidadSolicitante: { nombre: data.unidad_solicitante },
            establecimientoSolicitante: { nombre: data.establecimiento_solicitante },
            institucionSolicitante: { nombre: data.institucion_solicitante },
          },
          motivoCambio: data.motivo_cambio,
          mostrarBitacora: !!data.mostrar_bitacora,
        });
      }
    },
    async fetchCandidatosSeleccionados({ commit, state }) {
      const response = await bolsaNoContratadosService.getPersonasSeleccionadas(
        state.idOferta
      );
      if (response?.status === 200) {
        commit(
          "SET_CANDIDATOS_SELECCIONADOS",
          response.data.map(mapPersona)
        );
      }
    },
    async fetchCandidatosDescartados({ commit, state }) {
      const response = await bolsaNoContratadosService.getPersonasRemovidas(
        state.idOferta
      );
      if (response?.status === 200) {
        commit(
          "SET_CANDIDATOS_DESCARTADOS",
          response.data.map(mapPersona)
        );
      }
    },
    setDetalleCandidato({ commit }, detalle) {
      commit("SET_DETALLE_CANDIDATO", detalle);
    },
    moverCandidato({ commit }, { id, accion }) {
      if (accion === "descartar") {
        commit("MOVER_A_DESCARTADOS", id);
      } else if (accion === "seleccionar") {
        commit("MOVER_A_SELECCIONADOS", id);
      }
    },
    async fetchBitacora({ commit, state }) {
      const response = await bolsaNoContratadosService.getBitacora(
        state.idOferta
      );
      if (response?.status === 200) {
        const mapped = response.data.map((item, mapIdx) => {
          const uid = item._id ?? item.id_oferta_gestion_cambio ?? mapIdx;
          return {
            id: item.id_oferta_gestion_cambio,
            _uid: uid,
            nombres: item.nombre_modificador,
            cargo: item.plaza,
            fecha: formatFecha(item.fecha_modificacion),
            motivo: item.motivo,
            posee_documentos: item.posee_documentos,
            removidos: (item.modificaciones?.removidos ?? []).map((p, idx) => ({
              _key: `${uid}-r-${idx}`,
              documento: p.numero_documento,
              nombres: p.nombres,
              apellidos: p.apellidos,
            })),
            seleccionados: (item.modificaciones?.seleccionados ?? []).map((p, idx) => ({
              _key: `${uid}-s-${idx}`,
              documento: p.numero_documento,
              nombres: p.nombres,
              apellidos: p.apellidos,
            })),
          };
        });
        commit("SET_BITACORA", mapped);
      }
    },
  },
  getters: {
    idSolicitud: (state) => state.idOferta,
    datosSolicitud: (state) => state.datosSolicitud,
    listaCandidatosSeleccionados: (state) => state.listaCandidatosSeleccionados,
    listaCandidatosDescartados: (state) => state.listaCandidatosDescartados,
    totalSeleccionados: (state) => state.totalSeleccionados,
    totalDescartados: (state) => state.totalDescartados,
    detalleCandidato: (state) => state.detalleCandidato,
    bitacora: (state) => state.bitacora,
  },
};
